import {
    IDatiqInput,
    IDatiqOption,
    emptyDatiqInput,
} from '@dat/datiq-components-pkg/utils';
import { DATIQ_DEFAULT_ARRAY } from '@dat/datiq-core/models';

export interface IDatiqTimelineInputTab extends IDatiqOption {
    seperator?: boolean;
}

export interface IDatiqTimelineInput extends IDatiqInput {
    tabs: IDatiqTimelineInputTab[];
    multiple?: boolean;
}

export const emptyDatiqTimelineInput: IDatiqTimelineInput = {
    ...emptyDatiqInput,
    tabs: DATIQ_DEFAULT_ARRAY as IDatiqTimelineInputTab[],
};
